import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@components/Form/Checkbox';
import {
  Actions,
  Track,
  NoContent,
  Column,
  Link,
} from '@components/Tracks/style';
import routes from '@routes';
import { ActionButton } from '@styles/globalStyles';
import TrackDownloadTooltipBody from '@components/TrackDownloadTooltipBody';
import Tooltip from '@components/Tooltip';
import { tracksOptions } from '@app/consts';

const Tracks = ({
  items,
  hideAlbumName,
  selectedIds,
  setFieldValue,
  stems,
}) => {
  if (items.length) {
    const onChangeHandler = () => {
      setTimeout(() => {
        setFieldValue('selectAll', selectedIds.length !== items.length);
      }, 1);
    };

    return items.map(track => {
      const fileOptions = [];
      tracksOptions.forEach(({ label, value }) => {
        if (track[value] && track[value].url) {
          fileOptions.push({ label: stems ? 'Stems' : label, value });
        }
      });

      return (
        <Checkbox
          key={track.id}
          name="ids"
          value={track.id}
          onChange={onChangeHandler}
          extraPadding={false}
        >
          <Track>
            <Column flex={0.3}>{track.number}</Column>
            <Column flex={2}>{track.name}</Column>
            <Column flex={1}>{track.version}</Column>
            {!hideAlbumName ? (
              <Column flex={1}>
                <Link to={routes.album(track.album_uuid, stems)}>
                  {track.album_name}
                </Link>
              </Column>
            ) : null}
            <Actions flex={1} right>
              <Tooltip
                tooltipBody={
                  <TrackDownloadTooltipBody
                    options={fileOptions}
                    id={track.id}
                  />
                }
              >
                <ActionButton as="button" type="button">
                  <img src="/images/icons/download.svg" alt="download" />
                </ActionButton>
              </Tooltip>
            </Actions>
          </Track>
        </Checkbox>
      );
    });
  }

  return <NoContent>No tracks found</NoContent>;
};

Tracks.defaultProps = {
  hideAlbumName: false,
};

Tracks.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  hideAlbumName: PropTypes.bool,
  selectedIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default Tracks;
